const TypeReservant = {
  ASSOCIATION: 1,
  ENTREPRISE: 2,
  ADMINISTRATION: 3,
  PARTICULIER: 4,
};

export default TypeReservant;
